"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createStyles = _interopRequireDefault(require("@material-ui/core/styles/createStyles"));
var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var useStyles = (0, _makeStyles.default)(theme => (0, _createStyles.default)({
  inputLabelRoot: {
    // color: theme.palette.custom.grey.light,
    '&:focused': {
      color: 'red'
    }
  },
  inputLabelFocused: {
    color: 'red'
  },
  inputRoot: {
    backgroundColor: theme.palette.primary.light,
    maxHeight: '46px',
    width: '100%',
    // color: theme.palette.custom.grey.light,
    padding: theme.spacing(2, 0),
    border: '2px solid transparent',
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 500
  },
  inputRootFocused: {
    border: "2px solid ".concat(theme.palette.secondary.main),
    borderRadius: '3px'
  },
  inputRootDisabled: {
    backgroundColor: 'transparent',
    color: theme.palette.primary.light,
    // border: `1px dashed ${theme.palette.custom.grey.main}`,
    borderRadius: '3px'
  },
  inputError: {
    border: "2px solid ".concat(theme.palette.secondary.main),
    borderRadius: '3px'
  },
  input: {
    border: 'none',
    paddingLeft: theme.spacing(2)
  }
}), {
  name: 'FooterTextField'
});
var _default = exports.default = useStyles;